import CourseOfActionContentModel, * as courseOfActionContentModels from './contentmodel';

export const ContentModels = courseOfActionContentModels;
export const ContentModel = CourseOfActionContentModel;

import './style.css';

export const description = "This is the course of action activity.";
export const instructions = "";



// WEBPACK FOOTER //
// ./app_modules/course-of-action-activity/src/index.js